import { memo } from "react";
interface Props {
  className?: string;
}
function ApplePayIcon({ className }: Props) {
  return (
    <svg
      width="37"
      height="26"
      viewBox="0 0 37 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="1.13911"
        y="0.801507"
        width="35.0197"
        height="24.1247"
        rx="4.28018"
        fill="white"
      />
      <rect
        x="1.13911"
        y="0.801507"
        width="35.0197"
        height="24.1247"
        rx="4.28018"
        stroke="#F2F4F7"
        strokeWidth="0.778215"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6299 9.06956C10.3289 9.4347 9.8473 9.72269 9.36572 9.68155C9.30553 9.18784 9.5413 8.66328 9.8172 8.33929C10.1182 7.96387 10.6449 7.69644 11.0713 7.67587C11.1215 8.19015 10.9258 8.69414 10.6299 9.06956ZM11.0663 9.77912C10.6421 9.75409 10.255 9.90992 9.94228 10.0358C9.74106 10.1168 9.57066 10.1854 9.44102 10.1854C9.29555 10.1854 9.11812 10.1131 8.9189 10.032C8.65786 9.92569 8.35942 9.80414 8.04646 9.80998C7.32912 9.82026 6.66194 10.2368 6.29574 10.9002C5.54328 12.2271 6.1001 14.1916 6.82748 15.2716C7.18364 15.8064 7.61004 16.3927 8.17187 16.3721C8.41905 16.3626 8.59685 16.2852 8.78086 16.2052C8.99271 16.113 9.21278 16.0173 9.5564 16.0173C9.88811 16.0173 10.0986 16.1105 10.3006 16.2C10.4927 16.2851 10.6771 16.3669 10.951 16.3618C11.5329 16.3516 11.8991 15.827 12.2552 15.2922C12.6396 14.7181 12.8085 14.1579 12.8341 14.0729L12.8371 14.063C12.8365 14.0624 12.8318 14.0602 12.8235 14.0563L12.8235 14.0563L12.8234 14.0562L12.8234 14.0562C12.6949 13.9959 11.7128 13.535 11.7034 12.2991C11.694 11.2617 12.4824 10.736 12.6065 10.6533C12.614 10.6483 12.6191 10.6449 12.6214 10.6431C12.1198 9.88197 11.3372 9.79969 11.0663 9.77912ZM15.0944 16.3056V8.28803H18.029C19.544 8.28803 20.6025 9.35773 20.6025 10.9211C20.6025 12.4845 19.5239 13.5645 17.9889 13.5645H16.3084V16.3056H15.0944ZM16.3085 9.3368H17.7081C18.7615 9.3368 19.3635 9.91279 19.3635 10.9259C19.3635 11.939 18.7615 12.5202 17.7031 12.5202H16.3085V9.3368ZM24.6108 15.3437C24.2898 15.9711 23.5825 16.3671 22.82 16.3671C21.6913 16.3671 20.9037 15.678 20.9037 14.6391C20.9037 13.6106 21.6662 13.0192 23.0758 12.9317L24.5908 12.8392V12.3969C24.5908 11.7438 24.1744 11.3889 23.432 11.3889C22.82 11.3889 22.3735 11.7129 22.2832 12.2066H21.1896C21.2248 11.1678 22.1779 10.4118 23.4671 10.4118C24.8566 10.4118 25.7596 11.1575 25.7596 12.3146V16.3054H24.6359V15.3437H24.6108ZM23.1458 15.4157C22.4987 15.4157 22.0874 15.0968 22.0874 14.6082C22.0874 14.1043 22.4837 13.8111 23.2411 13.7648L24.5906 13.6774V14.13C24.5906 14.8808 23.9685 15.4157 23.1458 15.4157ZM29.4868 16.6191C29.0002 18.0231 28.4434 18.4859 27.2595 18.4859C27.1692 18.4859 26.8682 18.4756 26.798 18.4551V17.4934C26.8732 17.5036 27.0588 17.5139 27.1542 17.5139C27.6909 17.5139 27.9919 17.2825 28.1775 16.6808L28.2879 16.326L26.2311 10.4889H27.5003L28.93 15.2254H28.955L30.3847 10.4889H31.6188L29.4868 16.6191Z"
        fill="#282D46"
      />
    </svg>
  );
}
export default memo(ApplePayIcon);
